module.exports = __webpack_public_path__ + "static/media/1363469042 copia.58eaa828.jpg";